import { render, staticRenderFns } from "./Enrollee.vue?vue&type=template&id=52d599c6&scoped=true&"
import script from "./Enrollee.vue?vue&type=script&lang=js&"
export * from "./Enrollee.vue?vue&type=script&lang=js&"
import style0 from "./Enrollee.vue?vue&type=style&index=0&id=52d599c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d599c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VCol,VLayout,VRow,VTooltip})
